import { apiClient } from '@/http/apiClient';
import { buildQuery } from '@/http/url';
import { AxiosPromise } from 'axios';
const rootPath = 'UserRoles';


class UserRoleService {
  
    public async getRoles(lang:string): Promise<any> {
        return apiClient.get(`${rootPath}${buildQuery({lang})}`);
    }
    public async getRolesByProfil(lang:string,profilName:string): Promise<any> {
        return apiClient.get(`${rootPath}${buildQuery({lang,profilName})}`);
    }

    public getTranslatedRole(id:string, lang:string): AxiosPromise<any> {
        return apiClient.get(`${rootPath}/${id}${buildQuery({lang})}`);
    }
    
}

export default new UserRoleService();